import Index from '../src/Componenets/Index';
import { UserAuthContextProvider } from '../src/context/UserAuthContext';
import { Routes, Route } from "react-router-dom";
import Details from '../src/Componenets/Details';
import ProtectedRoute from './Componenets/ProtectedRoute';
import Register from './Componenets/Register';
import 'bootstrap/dist/css/bootstrap.min.css';
// import Loader from "../src/Componenets/Loader"
import "../src/Componenets/loader.css";
import React, { useState, useEffect } from 'react';

function App() {

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
  }, [])
  return (
    <>
    {loading ? (<section className="spinnerhome">
            <div class="loader"></div>
        </section> ) : (
      <UserAuthContextProvider>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route exact path="/auth" element={<ProtectedRoute><Details /></ProtectedRoute>} />
          <Route exact path="/dashboard" element={<ProtectedRoute><Register /></ProtectedRoute>} />
          <Route path="*" element={<ProtectedRoute><Details /></ProtectedRoute>} />
        </Routes>
      </UserAuthContextProvider>

    )}
    </>
  );
}

export default App;
